import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { environment } from '../../../../environments/environment';
import { Component } from '@angular/core';

@Component({
    selector: 'app-nav',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatSidenavModule,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent {
    public title = environment.serverName;
    isHandset!: Observable<BreakpointState>;

    constructor(private breakpointObserver: BreakpointObserver) {
        // Initialize after DI so TS 5.9 doesn't treat breakpointObserver as used before assignment
        this.isHandset = this.breakpointObserver.observe(Breakpoints.Handset);
    }
}
